// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-expeditions-js": () => import("./../../../src/pages/expeditions.js" /* webpackChunkName: "component---src-pages-expeditions-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-itinerary-js": () => import("./../../../src/pages/itinerary.js" /* webpackChunkName: "component---src-pages-itinerary-js" */),
  "component---src-pages-styleguide-js": () => import("./../../../src/pages/styleguide.js" /* webpackChunkName: "component---src-pages-styleguide-js" */),
  "component---src-templates-expedition-js": () => import("./../../../src/templates/expedition.js" /* webpackChunkName: "component---src-templates-expedition-js" */)
}

